import { graphql } from 'gql';

export const projectListGql = graphql(`
    query projects($skip: Int, $take: Int, $where: ProjectItemDataFilterInput, $order: [ProjectItemDataSortInput!]) {
        projects(skip: $skip, take: $take, where: $where, order: $order) {
            totalCount
            pageInfo {
                hasNextPage
                hasPreviousPage
            }
            items {
                uniqueId
                priceNMC
                lotPrice
                actualPrice
                createdAt
                updatedAt
                authoredBy
                name
                isOwn
                subsidiaryId
                subsidiaryName
                stage
                status
                methodology
                contractType
                contractUniqueId
            }
        }
    }
`);

export const projectNameFilterGql = graphql(`
    query projectsNameFilter($where: FilterValueOfStringFilterInput) {
        projectsNameFilter(where: $where) {
            items {
                value
            }
        }
    }
`);

export const projectMethodologyFilterGql = graphql(`
    query projectsMethodologyFilter($where: FilterValueOfProjectMethodologyEnumFilterInput) {
        projectsMethodologyFilter(where: $where) {
            items {
                value
            }
        }
    }
`);

export const projectStageFilterGql = graphql(`
    query projectsStageFilter($where: FilterValueOfProjectStageEnumFilterInput) {
        projectsStageFilter(where: $where) {
            items {
                value
            }
        }
    }
`);

export const projectStatusFilterGql = graphql(`
    query projectsStatusFilter($where: FilterValueOfProjectStatusEnumFilterInput) {
        projectsStatusFilter(where: $where) {
            items {
                value
            }
        }
    }
`);

export const projectAuthoredByFilterGql = graphql(`
    query projectsAuthoredByFilter($where: FilterValueOfStringFilterInput) {
        projectsAuthoredByFilter(where: $where) {
            items {
                value
            }
        }
    }
`);

export const projectSubsidiaryFilterGql = graphql(`
    query projectsSubsidiaryFilter($where: FilterValueOfCompanyDataFilterInput) {
        projectsSubsidiaryFilter(where: $where) {
            items {
                value {
                    id
                    name
                }
            }
        }
    }
`);
